import { storageLocationIdFormat } from "@redotech/redo-warehouse-id";
import * as z from "zod";

export const deleteStorageLocations = {
  name: "deleteStorageLocations" as const,
  input: z.object({
    storageLocationIds: z.array(storageLocationIdFormat.schema).min(1).max(100),
  }),
  output: z.object({}),
};
